"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgSunOutline = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { d: 'M11 3a1 1 0 112 0v3.083a6.04 6.04 0 00-2 0V3zM8.524 7.11L6.12 4.706a1 1 0 10-1.414 1.414L7.11 8.523A6.034 6.034 0 018.524 7.11zM3 11h3.083a6.04 6.04 0 000 2H3a1 1 0 110-2zM7.212 15.616l-2.506 2.506a1 1 0 101.415 1.414l2.546-2.546a6.034 6.034 0 01-1.455-1.374zM11 21v-3.083a6.036 6.036 0 002 0V21a1 1 0 11-2 0zM15.477 16.89l2.644 2.645a1 1 0 001.415-1.414l-2.645-2.645a6.034 6.034 0 01-1.414 1.415zM21 13h-3.083a6.036 6.036 0 000-2H21a1 1 0 110 2zM16.99 8.667l2.545-2.546a1 1 0 10-1.414-1.414l-2.505 2.505c.535.404 1 .896 1.374 1.455z' }),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M16 12a4 4 0 11-8 0 4 4 0 018 0zm-2 0a2 2 0 11-4 0 2 2 0 014 0z' }))); };
exports.default = SvgSunOutline;
//# sourceMappingURL=SunOutline.js.map